module.exports = __webpack_public_path__ + "static/media/bbss_logo.db3f2a4a.png";